import React from "react";
import Modal from "react-bootstrap/Modal";

const ConfirmModal = ({
  show,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onClose,
  variant = "danger",
}) => {
  if (!show) return null;
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0 text-muted">{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn-secondary" onClick={onClose}>
          {cancelText}
        </button>
        <button
          type="button"
          className={
            variant === "danger" ? "btn-danger btn-sm" : "btn-primary btn-sm"
          }
          onClick={onConfirm}
        >
          {confirmText}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
